'use client';

import { useNavShortcuts } from './use-nav-shortcuts';

export function NavShortcuts(): null {
  useNavShortcuts();
  return null;
}
